<template>
  <div class="d-flex flex-center flex-column flex-column-fluid">
    <div class="w-lg-500px p-6 p-lg-15 mx-auto">
      <form id="kt_sign_in_form" class="form w-100" novalidate="novalidate"
            @submit.prevent="validateBeforeSubmit">
        <div class="text-center mb-10">
          <h1 class="text-dark mb-3 mt-10">{{ $t('auth.login') }}</h1>
        </div>

        <!-- Toggle email / téléphone -->
        <div class="d-flex justify-content-center mb-8">
          <div class="btn-group" role="group">
            <button type="button"
                    :class="['btn btn-sm', loginMode === 'email' ? 'btn-primary' : 'btn-light']"
                    @click="switchMode('email')">
              <i class="fas fa-envelope me-2"></i>{{ $t('auth.email') }}
            </button>
            <button type="button"
                    :class="['btn btn-sm', loginMode === 'phone' ? 'btn-primary' : 'btn-light']"
                    @click="switchMode('phone')">
              <i class="fas fa-phone me-2"></i>{{ $t('auth.phone') }}
            </button>
          </div>
        </div>

        <!-- Champ email -->
        <div v-if="loginMode === 'email'" class="fv-row mb-10">
          <label class="form-label fs-6 fw-bolder text-color required">{{ $t('auth.email') }}</label>
          <input v-model="loginData.email" autocomplete="off"
                 class="form-control form-control-lg form-control-solid" name="email" type="text"/>
        </div>

        <!-- Champ téléphone -->
        <div v-else class="fv-row mb-10">
          <label class="form-label fs-6 fw-bolder text-color required">{{ $t('auth.phone') }}</label>
          <vue-tel-input
            v-model="loginData.phone"
            :inputOptions="telInputOptions"
            :autoDefaultCountry="true"
            class="form-control form-control-solid"
            @country-changed="onCountryChanged"
            @input="onPhoneInput"
          />
        </div>

        <!-- Mot de passe -->
        <div class="fv-row mb-10">
          <div class="d-flex flex-stack mb-2">
            <label class="form-label fw-bolder fs-6 mb-0 text-color required">{{ $t('auth.password') }}</label>
          </div>
          <div class="password-input mb-5">
            <input v-model="loginData.password" autocomplete="off"
                   class="form-control form-control-lg form-control-solid" :type="inputType"/>
            <span class="toggle-password" @click="togglePasswordVisibility">
              <i :class="eyeIconClass"></i>
            </span>
          </div>
          <div class="d-flex flex-stack mb-2">
            <label class="form-label fw-bolder fs-6 mb-0 text-color"></label>
            <router-link :to="{ name: 'forgot-password' }" class="link-primary fs-6 fw-bolder">
              {{ $t('auth.forgot_password') }}
            </router-link>
          </div>
        </div>

        <div class="text-center mb-5">
          <button id="kt_sign_in_submit" :disabled="isLoading"
                  class="btn btn-lg btn-primary w-100 mb-5"
                  type="submit">
            <span class="indicator-label">{{ $t('auth.login') }}</span>
            <span class="indicator-progress">{{ $t('loading') }}
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>

        </div>
      </form>
    </div>
  </div>

 
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLoader } from '@/composables/loader'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

const store = useStore()
const router = useRouter()
const { t } = useI18n()
const { loading, stopLoading } = useLoader()

const loginMode = ref('email')

const loginData = ref({
  email: '',
  phone: '',
  phone_code: '',
  password: '',
  mode: 'email'
})

const isLoading = ref(false)
const showPassword = ref(false)


const inputType = computed(() => showPassword.value ? 'text' : 'password')
const eyeIconClass = computed(() => showPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye')

function togglePasswordVisibility() {
  showPassword.value = !showPassword.value
}

function switchMode(mode) {
  loginMode.value = mode
  loginData.value.mode = mode
  loginData.value.email = ''
  loginData.value.phone = ''
  loginData.value.phone_code = ''
}

function onCountryChanged(country) {
  loginData.value.phone_code = '+' + country.dialCode
}

function onPhoneInput(number, phoneObject) {
  if (phoneObject) {
    loginData.value.phone = phoneObject.nationalNumber ?? number
    loginData.value.phone_code = '+' + phoneObject.countryCallingCode
  }
}



function validateBeforeSubmit() {
  loading('kt_sign_in_submit')
  isLoading.value = true

  store.dispatch('auth/login', loginData.value)
     .then(() => {
      window.toastr['success'](t('notification.logged'))

      router.push({ name: 'shop-dashboard' })
    })
    .catch()
    .finally(() => {
      stopLoading('kt_sign_in_submit')
      isLoading.value = false
    })
}
</script>

<style scoped>
.text-color {
  color: rgba(16, 16, 16, 0.50);
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

#eye-icon {
  font-size: 1.2em;
}
</style>
